module.exports = __webpack_public_path__ + "img/hunshalifu.f0dff1f8.png";